import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import ScrollToTop, { goToTop } from './ScrollTop'
import SimpleFooter from './SimpleFooter'
import SimpleNavbar from './SimpleNavbar'

function Layout() {
  const location = useLocation();

  useEffect(() => {
    goToTop();
  }, [location]);

  return (
    <div className="App">
      <ScrollToTop />
      <SimpleNavbar />
      <main>
        <Outlet />
      </main>
      <SimpleFooter />
    </div>
  )
}

export default Layout